/* eslint-disable no-param-reassign */
import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import LcpPreload from 'components/shared/LcpPreload'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

interface PageProps {
  data: {
    page: {
      title?: string
      path?: string
      seo: any
      flexContent: any
    }
  }
  location?: any
  prefix?: string
}

const PageTemplate: React.FC<PageProps> = ({
  data: {
    page: { flexContent, seo },
  },
  location = {},
  prefix = 'page_Flexcontent',
}) => {
  // add breadcrumb list schema
  if (seo) {
    seo.schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: location.origin,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: seo.title,
            item: location.href,
          },
        ],
      },
    ]

    // Add Organization structured data if homepage
    if (location.pathname === '/' || location.pathname === '') {
      seo.schema.push({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'PFC',
        url: location.origin,
        logo: `${location.origin}/img/logo.png`,
        description:
          'Perfect Fire Control vindt dat mensen in elk gebouw zorgeloos moeten kunnen werken. Brandveiligheid is een belangrijke voorwaarde om dit te realiseren. Daarom geloven wij in gedegen advies, professionele implementatie van brandveiligheid en een helder beheerplan, dat we structureel uitvoeren.',
        email: 'info@perfectfirecontrol.nl',
        telephone: '033 303 60 85',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Edisonweg 11G',
          addressLocality: 'Bunschoten-Spakenburg',
          postalCode: '3752 LV',
          addressCountry: 'Nederland',
        },
        sameAs: [
          'https://www.facebook.com/PerfectFireControl/',
          'https://www.linkedin.com/company/perfect-fire-control/',
          'https://www.instagram.com/perfectfirecontrol/',
        ],
      })
    }
  }

  return (
    <Layout>
      <SEO seo={seo} />
      <LcpPreload flexContent={flexContent} />
      <FlexContentHandler
        prefix={prefix}
        fields={flexContent}
        location={location}
      />
    </Layout>
  )
}

export const pageQuery = graphql`
  query pageById($pageId: String!) {
    page: wpPage(id: { eq: $pageId }) {
      ...generalPageFragment
    }
  }
`

export default PageTemplate
